(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smj-contact"] && !Shopify.designMode) return;
  try {
    
function initSMJContact(){
 const form=document.getElementById('SMJContactForm');
 if(!form||form.dataset.ready)return;
 form.dataset.ready='true';
 const topic=form.querySelector('#SMJTopic');
 const hint=form.querySelector('#SMJTopicHelp');
 const reference=form.querySelector('#SMJReference');
 const product=new URLSearchParams(window.location.search).get('product');
 if(product&&!reference.value){reference.value=product.slice(0,250);topic.value='piece';}
 function updateHint(){hint.textContent=hint.dataset[topic.value]||hint.dataset.general;}
 topic.addEventListener('change',updateHint);updateHint();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSMJContact);}else{initSMJContact();}
document.addEventListener('shopify:section:load',initSMJContact);

  } catch(e) { console.error(e); }
})();
})();
